module.exports = __webpack_public_path__ + "static/media/low-rating.2b2a9ef3.png";